import { render, staticRenderFns } from "./Passport.vue?vue&type=template&id=578c8582&"
import script from "./Passport.vue?vue&type=script&lang=ts&"
export * from "./Passport.vue?vue&type=script&lang=ts&"
import style0 from "./Passport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports